import api from './client';

export interface Branding {
  name: string;
}

// Unauthenticated: the login page and public forms need the name before a token exists.
export async function getBranding(): Promise<Branding> {
  return api.get<Branding>('/branding', { skipAuth: true });
}
